class User {
  constructor() {

    if(document.querySelector('.user') != null && document.querySelector('.user') != undefined) {
      this.setEventsData();
      this.setEventsNotifications();
      this.setEventsDetails();
    }

  }
  
  setEventsData() {

    if(document.querySelector('.user__data') != null && document.querySelector('.user__data') != undefined) {
      var userData = document.querySelector('.user__data');
      var btnChange = userData.querySelectorAll('.data__change');
      var btnCancel = userData.querySelectorAll('.cancel');
      var btnSave = userData.querySelectorAll('.save');
  
      btnChange.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          btn.parentNode.classList.add('changing');
        });
      });
  
      btnCancel.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          btn.parentNode.parentNode.classList.remove('changing');
        });
      });
  
      btnSave.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          btn.parentNode.parentNode.classList.remove('changing');
        });
      });

    }
  }

  setEventsNotifications() {

    if(document.querySelector('.user__notifications') != null && document.querySelector('.user__notifications') != undefined) {
      var userNotifications = document.querySelector('.user__notifications');
      var checkAll = userNotifications.querySelector('#check1');
      var checks = userNotifications.querySelectorAll('input[type=checkbox]');

      function verifyChecks() {
        var checked = 0;

        checks.forEach(check => {
          if(check != checkAll && check.checked) {
            checked++;
          }
        });

        if(checked >= (checks.length - 1)) {
          checkAll.checked = true;
        } else {
          checkAll.checked = false;
        }
      }

      checks.forEach(check => {
        if(check != checkAll) {
          check.addEventListener('change', function() {
            verifyChecks();
          });
        }
      });

      checkAll.addEventListener('change', function(){
        if(checkAll.checked) {
          checks.forEach(check => {
            check.checked = true;
          });
        } else {
          checks.forEach(check => {
            check.checked = false;
          });
        }
      });

    }
  }

  setEventsDetails() {  

    var acc = document.getElementsByClassName("accordion__top");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function(e) {
        e.preventDefault();
        var panel = this.nextElementSibling;
        var filter = this.parentNode;
        if (filter.classList.contains('active')) {
          panel.style.maxHeight = 0;
          filter.classList.toggle("active");
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          filter.classList.toggle("active");
        };
      });
    };


    // textarea

    var reply = document.querySelectorAll('.user__reply');

    reply.forEach(r => {
      var textarea = r.querySelector('textarea');
      var maxLength = textarea.getAttribute('maxLength');
      var counter = r.querySelector('.counter__number');

      textarea.addEventListener("keyup", function() {
        var text = textarea.value.length;
        counter.textContent = (maxLength - text);
      });
    });

  };
    
}

$(document).ready(function() {
  const user = new User();
});
